import { h } from 'preact';
import { getInstitutionalHoldings, getInsiderActions } from '@os/cloudquote';
import { formatNumber, intlDateNode } from '../../lib/util';
import createDataTable, { tableUtils } from '../cloudquote-data-table';
import { Text } from 'preact-i18n';

const INTL_NS = 'stock-data-table';
const INTL_NS_HOLDINGS = 'holdings';

export const HoldingsDataTable = createDataTable({
	headers: [
		<Text id={`${INTL_NS}.${INTL_NS_HOLDINGS}.holder`} />,
		<Text id={`${INTL_NS}.${INTL_NS_HOLDINGS}.shares`} />,
		<Text id={`${INTL_NS}.${INTL_NS_HOLDINGS}.dateReported`} />,
		<Text id={`${INTL_NS}.${INTL_NS_HOLDINGS}.value`} />
	],

	cells: [
		'Institution Name',
		tableUtils.formatField('Volume of Security Held', (value) => formatNumber(value, { Comma: true })),
		tableUtils.formatField('Report Date', intlDateNode),
		tableUtils.formatField('Value of Security Held', (value) => formatNumber(value, { Comma: true, Decimals: 2 }))
	],
	sort: tableUtils.sort.descending.byKey('Volume of Security Held'),
	maxRows: 10,
	apiMethod: getInstitutionalHoldings
});

export const InsiderTransactionsDataTable = createDataTable({
	headers: [
		<Text id={`${INTL_NS}.${INTL_NS_HOLDINGS}.insider`} />,
		<Text id={`${INTL_NS}.${INTL_NS_HOLDINGS}.transaction`} />,
		<Text id={`${INTL_NS}.${INTL_NS_HOLDINGS}.date`} />,
		<Text id={`${INTL_NS}.${INTL_NS_HOLDINGS}.value`} />,
		<Text id={`${INTL_NS}.${INTL_NS_HOLDINGS}.shares`} />
	],
	cells: [
		'Insider',
		formatAcquiredDisposed,
		tableUtils.formatField('Transaction Date', intlDateNode),
		formatInsiderValue,
		tableUtils.formatField('Shares', (value) => formatNumber(value, { Comma: true }))
	],
	sort: tableUtils.sort.descending.dateByKey('Transaction Date'),
	maxRows: 50,
	apiMethod: getInsiderActions
});

function formatAcquiredDisposed({ columns, row }) {
	const priceRange = formatNumber(row[columns.indexOf('Price Range')], { Prefix: '$', Decimals: 2, Default: 'N/A' });
	const acquiredOrDisposed = acquiredDisposedToString(row[columns.indexOf('Aquired/Disposal')]);
	return <Text id={`${INTL_NS}.${INTL_NS_HOLDINGS}.${acquiredOrDisposed}`} fields={{ priceRange }} />;
}

function formatInsiderValue({ columns, row }) {
	return formatNumber(
		row[columns.indexOf('Shares')] * row[columns.indexOf('Price Range')],
		{ Comma: true, Decimals: 2, Default: '-' }
	);
}

function acquiredDisposedToString(aOrD) {
	return aOrD.toLowerCase() === 'a'
		? 'acquisition'
		: aOrD.toLowerCase() === 'd'
			? 'disposition'
			: 'unknown';
}
